import React from 'react'  
import { format, isValid } from "date-fns";
import { constructDetailUrl } from '../../../utils/constants/urls';

const MapSearchResults = (props) => {
	const {
        mapResults,
        totalhits,
    } = props;


    if (mapResults != null){
        if ( Object.keys( mapResults ).length && mapResults.length){
            return (
                <div>
                    <div className="wells_in_region">
                        <p className="well_count_text"><span className="counter_text">{totalhits}</span> wells in this region</p>
                    </div>
                    <div className="results_container">
                        {mapResults.map( (mapResults, idx) => {
                            const jobEndDate = mapResults.JobEndDate ? new Date(mapResults.JobEndDate) : null;
                            const formattedDate = jobEndDate && isValid(jobEndDate)
                                ? format(jobEndDate, 'MMMM do, yyyy')
                                : 'N/A';

                            return (
                                //this key value is not a db identifier, but pkey is null
                                <div key={ idx }>
                                    <div className="map_wells_card">
                                        <h2 className="well_card_header"><a className="well_link" href={constructDetailUrl(mapResults.APINumber)}>{ mapResults.WellName}</a></h2>
                                        <a href={constructDetailUrl(mapResults.APINumber)}>
                                            <button className="wells_button">Disclosure(s)</button>
                                        </a><br />
                                        <div className="wells_header">
                                            <p className="wellcard_oper" title="Operator means the individual, company, trust, or foundation responsible for the exploration, development, and production of an oil or gas well or lease.">Operated by&nbsp;</p>
                                            <p className="wellcard_oper_param">{mapResults.OperatorClean}</p>
                                        </div>
                                        <table className="wells_location_card"> 
                                            <tbody>
                                                <tr className="location_block"><td>API<span className="param_result">{mapResults.APINumber}</span></td></tr>
                                                <tr className="location_block"><td>State<span className="param_result">{mapResults.StateName}</span></td></tr>
                                                <tr className="location_block"><td>County<span className="param_result">{mapResults.CountyName}</span></td></tr>
                                                <tr className="location_block"><td>Job End Date<span className="param_result">{formattedDate}</span></td></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )
                        })}

                    </div>
                </div>
            )
        }
        else if ( mapResults.length === 0 ){
            return (
                <div className="wells_in_region">
                    <div className="well_count_text">
                        <p>No results for this area</p>
                    </div>
                </div>
            )
        }
    }
    else {
        return('')
    }
}

export default MapSearchResults
